import * as CONST from "../const/action.const";
import { type_of_transfer_students } from "../data/warhouse";
import { findObjectFromArrayWithId, removeObjectWithId } from "../helpers/utils";

const initialState = {
  all_type_classes_list: [],
  classes_list: [],
  workshops_list: [],
  my_workshops:[],
  new_class: null,
  new_workshop: null,
  info_class: null,
  info_workshop: null,
  details_class: null,//public page
  students_in_class: [],
  students_in_workshop: [],
  new_student_in_class: false,
  new_student_in_workshop: false,
  submit_attendance_students_class: null,
  submit_attendance_students_workshop: null,
  attendance_in_class: [],
  attendance_in_workshop: [],
};

export default function reducer(state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case CONST.CREATE_CLASS_SUCCESS:
      return {
        ...state,
        new_class: payload,
        classes_list: state.classes_list.concat(payload),
      };
    case CONST.CREATE_CLASS_FAILURE:
      return {
        ...state,
        new_class: null,
      };
    case CONST.GET_CLASSES_LIST_SUCCESS:
      return {
        ...state,
        classes_list: payload.reverse(),
      };
    case CONST.GET_CLASSES_LIST_FAILURE:
      return {
        ...state,
        classes_list: [],
      };
    case CONST.GET_ALL_TYPE_OF_CLASSES_LIST_SUCCESS:
      return {
        ...state,
        all_type_classes_list: payload.reverse(),
      };
    case CONST.GET_ALL_TYPE_OF_CLASSES_LIST_FAILURE:
      return {
        ...state,
        all_type_classes_list: [],
      };
    case CONST.GET_WORKSHOPS_LIST_SUCCESS:
      return {
        ...state,
        workshops_list: payload.reverse(),
      };
    case CONST.GET_WORKSHOPS_LIST_FAILURE:
      return {
        ...state,
        workshops_list: [],
      };
    case CONST.GET_MY_WORKSHOPS_SUCCESS:
      return {
        ...state,
        my_workshops: payload.reverse(),
      };
    case CONST.GET_MY_WORKSHOPS_FAILURE:
      return {
        ...state,
        my_workshops: [],
      };
    case CONST.FIND_CLASS_SUCCESS:
      return {
        ...state,
        info_class: payload,
      };
    case CONST.FIND_CLASS_FAILURE:
      return {
        ...state,
        info_class: null,
      };
    case CONST.UPDATE_CLASS_SUCCESS:
      return {
        ...state,
        info_class: payload,
      };
    case CONST.UPDATE_CLASS_FAILURE:
      return {
        ...state,
        info_class: payload,
      };
    case CONST.DELETE_CLASS_SUCCESS:
      const new_classes_list=removeObjectWithId(state.classes_list,payload)
      return {
        ...state,
        info_class: new_classes_list,
      };
    case CONST.DELETE_CLASS_FAILURE:
      return {
        ...state,
        info_class: state.classes_list,
      };
    case CONST.FIND_CLASS_DETAIL_SUCCESS://public
      return {
        ...state,
        details_class: payload,
      };
    case CONST.FIND_CLASS_DETAIL_FAILURE:
      return {
        ...state,
        details_class: null,
      };
    case CONST.FIND_WORKSHOP_SUCCESS:
      return {
        ...state,
        info_workshop: payload,
      };
    case CONST.FIND_WORKSHOP_FAILURE:
      return {
        ...state,
        info_workshop: payload,
      };
    case CONST.UPDATE_WORKSHOP_SUCCESS:
      return {
        ...state,
        info_workshop: payload,
      };
    case CONST.UPDATE_WORKSHOP_FAILURE:
      return {
        ...state,
        info_workshop: payload,
      };
    case CONST.DELETE_WORKSHOP_SUCCESS:
      const new_workshops_list=removeObjectWithId(state.workshops_list,payload)
      console.log("new_workshops_list",new_workshops_list)
      return {
        ...state,
        workshops_list: new_workshops_list,
      };
    case CONST.DELETE_WORKSHOP_FAILURE:
      return {
        ...state,
        workshops_list: state.workshops_list,
      };
    case CONST.ADD_STUDENTS_TO_CLASS_SUCCESS:
      var archive = [...state.classes_list];
      for (var i in archive) {
        archive[i] = { ...state.classes_list[i] };
        if (archive[i].id === payload.classId) {
          let cloneMe= [...archive[i].studentsDtos]
          payload.students.forEach(newStudent => {
             cloneMe.push(newStudent)
          });
          archive[i].studentsDtos = cloneMe
        }
      }
      return {
        ...state,
        new_student_in_class: true,
        classes_list: archive,
        students_in_class: state.students_in_class.concat(payload.students)
      };
    case CONST.ADD_STUDENTS_TO_CLASS_FAILURE:
      return {
        ...state,
        new_student_in_class: false,
      };
    case CONST.FIND_STUDENTS_IN_CLASS_SUCCESS:
      return {
        ...state,
        students_in_class: payload.reverse(),
      };
    case CONST.FIND_STUDENTS_IN_CLASS_FAILURE:
      return {
        ...state,
        students_in_class: [],
      };
    case CONST.FIND_STUDENTS_IN_WORKSHOP_SUCCESS:
      return {
        ...state,
        students_in_workshop: payload.reverse(),
      };
    case CONST.FIND_STUDENTS_IN_WORKSHOP_FAILURE:
      return {
        ...state,
        students_in_workshop: [],
      };
    case CONST.SUBMIT_ATTENDANCE_IN_CLASS_SUCCESS:
      return {
        ...state,
        submit_attendance_students_class: payload,
      };
    case CONST.SUBMIT_ATTENDANCE_IN_CLASS_FAILURE:
      return {
        ...state,
        submit_attendance_students_class: null,
      };
    case CONST.SUBMIT_ATTENDANCE_IN_WORKSHOP_SUCCESS:
      return {
        ...state,
        submit_attendance_students_workshop: payload,
      };
    case CONST.SUBMIT_ATTENDANCE_IN_WORKSHOP_FAILURE:
      return {
        ...state,
        submit_attendance_students_workshop: null,
      };
    case CONST.GET_ATTENDANCE_IN_CLASS_SUCCESS:
      return {
        ...state,
        attendance_in_class: payload,
      };
    case CONST.GET_ATTENDANCE_IN_CLASS_FAILURE:
      return {
        ...state,
        attendance_in_class: [],
      };
    case CONST.GET_ATTENDANCE_IN_WORKSHOP_SUCCESS:
        return {
          ...state,
          attendance_in_workshop: payload,
        };
    case CONST.GET_ATTENDANCE_IN_WORKSHOP_FAILURE:
      return {
        ...state,
        attendance_in_workshop: [],
      };
    case CONST.TRANSFER_STUDENT_TO_CLASS_SUCCESS:
      var archive = [...state.classes_list];
      for (let i in archive) {
        archive[i] = { ...state.classes_list[i] };
        if (archive[i].id === payload.toClassId) {
          let cloneMe= [...archive[i].studentsDtos]
          payload.students.forEach(newStudent => {
              cloneMe.push(newStudent)
          });
          archive[i].studentsDtos = cloneMe
        }
        if (archive[i].id === payload.fromClassId && payload.transferType === type_of_transfer_students.CHANGE_SECTION) {
          let cloneMe= [...archive[i].studentsDtos]
          payload.students.forEach((newStudent, index) => {
              cloneMe.splice(index, 1)
          });
          archive[i].studentsDtos = cloneMe
        }
      }
      return {
        ...state,
        new_student_in_class: true,
        classes_list: archive,
        students_in_class: state.students_in_class.concat(payload.students)
      };
    case CONST.TRANSFER_STUDENT_TO_CLASS_FAILURE:
      return {
        ...state,
        new_student_in_class: false,
      };
    
    default:
      return state;
  }
}
